export default __webpack_public_path__ + "static/media/IBMCheckMarkOutline.2fca7e13.svg";